module.exports = __webpack_public_path__ + "img/icon5.9c002cb8.png";